module.exports = __webpack_public_path__ + "a09f82bbe2860a8685026e9463027c29.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/johannes-ewald.jpg
 ** module id = 414
 ** module chunks = 0
 **/